import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";

import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  selectClientReservation,
  closeClientReservationSelector,
} from "store/actions/mainUserActions";

import Icon from "@mui/material/Icon";

function ClientReservationSelector() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { isOpen, reservations } = useSelector(
    (state) => state.mainUserReducer?.clientReservationSelection || {}
  );

  const handleClose = () => {
    dispatch(closeClientReservationSelector());
  };

  const handleSelectReservation = (reservation) => {
    dispatch(selectClientReservation(reservation));
  };

  return (
    <Dialog
      open={isOpen || false}
      onClose={handleClose}
      aria-labelledby="reservation-selector-title"
      maxWidth="sm"
      fullWidth
    >
      <MDBox
        sx={({ palette: { white, background } }) => ({
          backgroundColor: darkMode ? background.sidenav : white.main,
        })}
      >
        <DialogTitle id="reservation-selector-title">
          {t("selectYourReservation") || "Select your reservation"}
        </DialogTitle>
        <DialogContent>
          <List>
            {reservations &&
              reservations.map((reservation, index) => {
                const isManagerMode = reservation?.apartmentId === "MANAGER_MODE";

                return (
                  <ListItem key={reservation?.uid || `option-${index}`} disablePadding>
                    <ListItemButton onClick={() => handleSelectReservation(reservation)}>
                      {isManagerMode && (
                        <ListItemIcon>
                          <Icon fontSize="large" color="info">
                            admin_panel_settings
                          </Icon>
                        </ListItemIcon>
                      )}
                      <ListItemText
                        primary={t(reservation?.projectName) || reservation?.projectName}
                        secondary={t(reservation?.apartmentName) || reservation?.apartmentName}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              })}
          </List>
        </DialogContent>
      </MDBox>
    </Dialog>
  );
}

export default ClientReservationSelector;
